// Lightweight, privacy-safe traffic attribution. No external services.
// UTM has priority over referrer; falls back to Direct. First-touch is persisted.
const KEY = "attribution_v1";

function classify() {
  const p = new URLSearchParams(window.location.search);
  const us = (p.get("utm_source") || "").trim().toLowerCase();
  const medium = (p.get("utm_medium") || "").trim();
  const campaign = (p.get("utm_campaign") || "").trim();
  if (us) {
    const map = { youtube: "YouTube", google: "Google", werkverdung: "Werkverdung", instagram: "Instagram", facebook: "Facebook", fb: "Facebook" };
    const source = map[us] || us.charAt(0).toUpperCase() + us.slice(1);
    return { source, medium, campaign };
  }
  const ref = document.referrer || "";
  if (ref) {
    let host = "";
    try { host = new URL(ref).hostname.toLowerCase(); } catch (e) {}
    const self = window.location.hostname.toLowerCase();
    if (host && !host.includes(self)) {
      if (host.includes("google.")) return { source: "Google Organic", medium: "organic", campaign: "" };
      if (host.includes("youtube.") || host.includes("youtu.be")) return { source: "YouTube", medium: "referral", campaign: "" };
      if (host.includes("instagram.")) return { source: "Instagram", medium: "referral", campaign: "" };
      if (host.includes("facebook.") || host.includes("fb.")) return { source: "Facebook", medium: "referral", campaign: "" };
      if (host.includes("werkverdung")) return { source: "Werkverdung", medium: "referral", campaign: "" };
      return { source: "Other", medium: "referral", campaign: "" };
    }
  }
  return { source: "Direct", medium: "", campaign: "" };
}

export function captureFirstTouch() {
  const current = classify();
  try {
    if (!localStorage.getItem(KEY)) {
      localStorage.setItem(KEY, JSON.stringify({ ...current, ts: Date.now() }));
    }
  } catch (e) {}
  return current;
}

export function getFirstTouch() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {}
  return classify();
}
